import { Download } from 'lucide-react';

import { CmsDownloadsProps } from '~/types/Cms';

const getFileName = (url: string): string => {
  try {
    const pathname = new URL(url).pathname;
    return decodeURIComponent(pathname.split('/').pop() || url);
  } catch {
    return url.split('/').pop() || url;
  }
};

const CmsDownloads = ({ data }: CmsDownloadsProps) => {
  const files = data?.files || [];

  if (files.length === 0) return null;

  return (
    <div className="cms-downloads">
      {data.title && <h4 className="cms-downloads__title mb-3">{data.title}</h4>}
      <ul className="cms-downloads__list list-unstyled m-0">
        {files.map((item, index) => {
          const label = item.label || getFileName(item.file);
          return (
            <li className="cms-downloads__item" key={`${item.file}-${index}`}>
              <a
                className="cms-downloads__link d-inline-flex align-items-center gap-2"
                download
                href={item.file}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Download aria-hidden="true" size={18} />
                <span>{label}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CmsDownloads;
